module.exports = __webpack_public_path__ + "static/media/furniture3.df230e1b.jpg";